import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useQuery } from "react-query";

export function useWorkordersWithAssignments(customerId?: number | "all", companyId?: number, siteId?: number) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["workordersWithAssignments", customerId, companyId, siteId],
    queryFn: async () => {
      if (typeof customerId === "number" && companyId && siteId)
        return await apiContext.workOrderApis.getWorkOrdersByCustomerAndSiteWithAssignments(customerId, siteId);
      else if (typeof customerId === "number" && companyId)
        return await apiContext.workOrderApis.getWorkOrdersByCustomerAndCompanyWithAssignments(customerId, companyId);
      else if (typeof customerId === "number") {
        return await apiContext.workOrderApis.getWorkOrdersByCustomerWithAssignments(customerId);
      } else if (customerId === "all") {
        return await apiContext.workOrderApis.getWorkOrdersWithAssignments();
      }
    },
  });
}
